import React, { useEffect, useState } from 'react';
import Toggle from '../ui-components/Toggle';
import Button from '../ui-components/Button';
import SettingRow from '../Setting/SettingRow';
import {
    sendAllLogs,
    sendExistingUserLogsOnInterval,
    cancelSendingLogsOnInterval,
    REASON,
} from 'flow/actions/client-log-actions';
import useAppContext from 'flow/hooks/useAppContext';
import {
    getAutomaticallySendClientLogs,
    hasLogs,
    saveAutomaticallySendClientLogs,
} from 'flow/utils/browser-utils';
import { useAppDispatch } from 'flow/hooks/useRedux';
import SettingsBlock from './SettingsBlock';
import FlowAlert from '../custom-components/FlowAlert';

const GeneralReportLogs = () => {
    const { i18next } = useAppContext();

    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [hasLogsState, setHasLogsState] = useState(false);
    const [sendLogsAutomatically, setSendLogsAutomatically] = useState(
        getAutomaticallySendClientLogs(),
    );
    const [logsSuccessfullySent, setLogsSuccessfullySent] = useState(false);

    useEffect(() => {
        const fetchLogs = async () => {
            const logsExist = await hasLogs();
            setHasLogsState(logsExist);
        };

        fetchLogs();
    }, []);

    const handleSendLogsAutomaticallySwitched = (enabled: boolean): void => {
        saveAutomaticallySendClientLogs(enabled);
        setSendLogsAutomatically(enabled);

        if (enabled) {
            dispatch(sendExistingUserLogsOnInterval);
            return;
        }
        cancelSendingLogsOnInterval();
    };

    const handleSendLogsManually = async () => {
        setLoading(true);
        try {
            await dispatch(sendAllLogs(REASON.USER_INITIATED));
            setLogsSuccessfullySent(true);
        } catch (error) {
            setLogsSuccessfullySent(false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SettingRow
                cta={
                    <Toggle
                        value={sendLogsAutomatically}
                        onChange={handleSendLogsAutomaticallySwitched}
                        text={i18next.t('logs.send_automatically')}
                    />
                }
                className="hover:bg-transparent"
                information={i18next.t('settings.general.logs.helptext')}
            >
                {i18next.t('logs.send_automatically')}
            </SettingRow>
            <div className="mt-5">
                <Button
                    children={i18next.t('settings.general.logs.send')}
                    onClick={handleSendLogsManually}
                    disabled={loading || !hasLogsState}
                    className="hover:bg-main w-full hover:text-white"
                    color="ghost"
                />
            </div>
            {logsSuccessfullySent ? (
                <SettingsBlock className="mt-6">
                    <FlowAlert
                        header={i18next.t(
                            'settings.general.logs.send.success.title',
                        )}
                        text={i18next.t(
                            'settings.general.logs.send.success.description',
                        )}
                    />
                </SettingsBlock>
            ) : null}
        </>
    );
};

export default GeneralReportLogs;
